export default __webpack_public_path__ + "static/media/icon-routeless.f52fff55.svg";